import { z } from 'zod';

export const StrategySchema = z.object({
  hrProjects: z.string().max(4000),
  investmentProjects: z.string().max(4000),
});
